import AppLayout, {
  AnnotationToolLayoutProps,
} from 'packages/at-shell/components/app-shell/app-layout';
import { FC, Suspense } from 'react';
import { useRecoilValue } from 'recoil';
import { uiThemeAtom } from 'packages/at-shell/state/recoil/ui';

/** Here so that app-routes.tsx can include Polaris pages without the left sidebar flashing white when user clicks on a different page the first time (due to suspense fallback) */
export const PolarisLayout: FC<
  React.PropsWithChildren<{ appLayout: AnnotationToolLayoutProps }>
> = ({ appLayout, children }) => {
  const theme = useRecoilValue(uiThemeAtom);
  return (
    <AppLayout
      {...appLayout}
      primaryView={<Suspense fallback={null}>{children}</Suspense>}
      theme={theme}
    />
  );
};
